import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import axios from "axios";
import Select from "react-select";
import pdfMake from "pdfmake/build/pdfmake";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
// import getDocDefinition from "./docDefinition";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const InvoicesandReceivedPayments = (props) => {
  const token = localStorage.getItem("Token");
  const gridRef = useRef();
  const tableContainerRef = useRef();
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalamount, setTotalAmount] = useState(0);
  const [columnby, setcolumnby] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState("");
  const [activeAccordion, setActiveAccordion] = useState(null);
  const locationid = localStorage.getItem("Location");
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [totalRows, setTotalRows] = useState(0);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  // const [PDF_PAGE_ORITENTATION, SET_PDF_PAGE_ORIENTATION] = useState(
  //   "landscape"
  // );
  // const [PDF_WITH_HEADER_IMAGE, SET_PDF_WITH_HEADER_IMAGE] = useState(true);
  // const [PDF_WITH_FOOTER_PAGE_COUNT, SET_PDF_WITH_FOOTER_PAGE_COUNT] = useState(
  //   true
  // );
  // const [PDF_HEADER_HEIGHT, SET_PDF_HEADER_HEIGHT] = useState(25);
  // const [PDF_ROW_HEIGHT, SET_PDF_ROW_HEIGHT] = useState(15);

  // const [PDF_ODD_BKG_COLOR, SET_PDF_ODD_BKG_COLOR] = useState("#fcfcfc");
  // const [PDF_EVEN_BKG_COLOR, SET_PDF_EVEN_BKG_COLOR] = useState("#fff");
  // const [PDF_WITH_CELL_FORMATTING, SET_PDF_WITH_CELL_FORMATTING] = useState(
  //   true
  // );
  // const [PDF_WITH_COLUMNS_AS_LINKS, SET_PDF_WITH_COLUMNS_AS_LINKS] = useState(
  //   true
  // );

  // const [PDF_SELECTED_ROWS_ONLY, SET_PDF_SELECTED_ROWS_ONLY] = useState(false);

  // const PDF_HEADER_COLOR = "#f8f8f8";
  // const PDF_INNER_BORDER_COLOR = "#dde2eb";
  // const PDF_OUTER_BORDER_COLOR = "#babfc7";
  // const PDF_LOGO =
  //   "https://raw.githubusercontent.com/AhmedAGadir/ag-grid-todo-list-react-typescript/master/src/assets/new-ag-grid-logo.png";

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState(
    []
    // inputValue: "",
    // width: 1,
    // height: 20,
    // fontSize: 15,
    // zeroFill: 10,
  );

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet
  const downloadPdf = () => {
    const pdf = new jsPDF();
    responseData.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.SaleId];
      const barcodeValue = `${item.SaleId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.deletePage(responseData.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  //Function for print
  const handlePrint = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    // Convert the PDF to a Blob object
    const pdfBlob = pdf.output("blob");

    // Create a URL for the Blob object
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open a new window with the URL
    const printWindow = window.open(pdfUrl);

    // Wait for the window to load and then print the PDF
    printWindow.addEventListener("load", () => {
      printWindow.print();
    });
  };

  //Function for download

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
  };

  // const toggleAccordion = (index) => {
  //   setActiveAccordion(activeAccordion === index ? null : index);
  // };

  // const renderAccordionIcon = (index) => {
  //   if (activeAccordion === index) {
  //     return <FontAwesomeIcon icon={faChevronUp} />;
  //   } else {
  //     return <FontAwesomeIcon icon={faChevronDown} />;
  //   }
  // };

  //Function for lookup receipt
  const paramObject = useParams();

  const apicall = () => {
    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/invoicereceivedpayments?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
          setRowCount(res.data.ResponseData[0].TotalRecord);

          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    apicall();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    // startdate,
    // enddate,
  ]);

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  }, []);

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const LinkRenderer = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.Num}
      </a>
    );
  };

  const LinkRenderer1 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.TransactionType}
      </a>
    );
  };

  const LinkRenderer2 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {/* if(data?.DueDate!==undefined){
            
            
            return Moment(data?.DueDate).format("YYYY-MM-DD")
          }else
          return "" */}
        {data?.DueDate !== undefined
          ? moment(data?.Date).format("YYYY-MM-DD")
          : ""}
      </a>
    );
  };

  const LinkRenderer3 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.MemoDescription}
      </a>
    );
  };

  const LinkRenderer4 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark list"
        rel="noopener noreferrer"
      >
        {/* {data?.Amount}  */}
        {data?.CustomerName !== undefined
          ? Number(data?.Amount).toFixed(2)
          : ""}
      </a>
    );
  };

  const LinkRenderer5 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark list"
        rel="noopener noreferrer"
      >
        {/* {data?.Amount}  */}
        {data?.CustomerName !== undefined
          ? Number(data?.OpenBalance).toFixed(2)
          : ""}
      </a>
    );
  };

  const LinkRenderer6 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.ModifiedDate
          ? moment(data?.ModifiedDate).format("YYYY-MM-DD")
          : "--"}
      </a>
    );
  };

  const LinkRenderer7 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.CreatedBy}
      </a>
    );
  };

  const LinkRenderer8 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.CreatedDate
          ? moment(data?.CreatedDate).format("YYYY-MM-DD")
          : "--"}
      </a>
    );
  };

  const LinkRenderer9 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.ModifiedBy}
      </a>
    );
  };

  const LinkRenderer10 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.Split}
      </a>
    );
  };

  const LinkRenderer11 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.DueDate ? moment(data?.DueDate).format("YYYY-MM-DD") : "--"}
      </a>
    );
  };

  const LinkRenderer12 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.Account}
      </a>
    );
  };

  const LinkRenderer13 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.VendorMessage}
      </a>
    );
  };

  const LinkRenderer14 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.Terms}
      </a>
    );
  };

  const LinkRenderer15 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.PaymentMethod}
      </a>
    );
  };

  const LinkRenderer16 = ({ data }) => {
    // Customize the cell content to render a link
    return (
      <a
        href={`/manage-sales/${data?.ID}`}
        className="text-dark"
        rel="noopener noreferrer"
      >
        {data?.CustomerID}
      </a>
    );
  };

  // const columnDefs = [
  //   {
  //     headerName: "Customer Name",
  //     field: "CustomerName",
  //     enableRowGroup: true,
  //   },
  //   {
  //     headerName: "Date",
  //     cellRendererFramework: LinkRenderer2,
  //     enableRowGroup: true,
  //   },

  //   {
  //     field: "TransactionType",
  //     cellRendererFramework: LinkRenderer1,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "MemoDescription",
  //     cellRendererFramework: LinkRenderer3,
  //     enableRowGroup: true,
  //   },
  //   { field: "Num", cellRendererFramework: LinkRenderer, enableRowGroup: true },
  //   {
  //     field: "Amount",
  //     cellRendererFramework: LinkRenderer4,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "OpenBalance",
  //     cellRendererFramework: LinkRenderer5,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "ModifiedDate",
  //     cellRendererFramework: LinkRenderer6,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "CreatedBy",
  //     cellRendererFramework: LinkRenderer7,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "CreatedDate",
  //     cellRendererFramework: LinkRenderer8,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "ModifiedBy",
  //     cellRendererFramework: LinkRenderer9,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "Split",
  //     cellRendererFramework: LinkRenderer10,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "DueDate",
  //     cellRendererFramework: LinkRenderer11,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "Account",
  //     cellRendererFramework: LinkRenderer12,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "VendorMessage",
  //     cellRendererFramework: LinkRenderer13,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "Terms",
  //     cellRendererFramework: LinkRenderer14,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "PaymentMethod",
  //     cellRendererFramework: LinkRenderer15,
  //     enableRowGroup: true,
  //   },
  //   {
  //     field: "CustomerID",
  //     cellRendererFramework: LinkRenderer16,
  //     enableRowGroup: true,
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "Customer Name",
      accessorKey: "CustomerName",
    },
    {
      header: "Date",
      accessorKey: "Date",
      Cell: ({ row }) => moment(row.original.Date).format("DD-MM-YYYY"),
    },
    {
      header: "TransactionType",
      accessorKey: "TransactionType",
    },
    {
      header: "MemoDescription",
      accessorKey: "MemoDescription",
    },
    {
      header: "Num",
      accessorKey: "Num",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Openbalance",
      accessorKey: "Openbalance",
      Cell: ({ row }) => {
        const amount = parseFloat(row?.original?.Openingbalance);
        // Check if amount is NaN or not a finite number
        if (isNaN(amount)) {
          return "$ 0.00";
        } else return `$${amount.toFixed(2)}`;
      },
    },
    {
      header: "ModifiedDate",
      accessorKey: "ModifiedDate",
    },
    {
      header: "CreatedBy",
      accessorKey: "CreatedBy",
    },
    {
      header: "CreatedDate",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("MM-DD-YYYY HH-mm-ss"),
    },
    {
      header: "ModifiedBy",
      accessorKey: "ModifiedBy",
    },
    {
      header: "Split",
      accessorKey: "Split",
    },
    {
      header: "DueDate",
      accessorKey: "DueDate",
      Cell: ({ row }) => moment(row.original.Date).format("DD-MM-YYYY"),
    },
    {
      header: "Account",
      accessorKey: "Account",
    },
    {
      header: "VendorMessage",
      accessorKey: "VendorMessage",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
    },
    {
      header: "PaymentMethod",
      accessorKey: "PaymentMethod",
    },
    {
      header: "CustomerID",
      accessorKey: "CustomerID",
    },
  ]);

  const defaultColDef = {
    sortable: true,
  };
  const autoGroupColumnDef = {
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      var res = valueA == valueB ? 0 : valueA > valueB ? 1 : -1;
      return res;
    },
    field: "athlete",
    sort: "asc",
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setLoading(true);

    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/invoicereceivedpayments?startdate=${""}&enddate=${""}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setData(res.data.ResponseData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  // useEffect(() => {
  //   onGridReady();
  // }, [onGridReady]);

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `InvoicesAndReceivedPayments_.xlsx`);
  };

  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(responseData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `InvoicesAndReceivedPayments_.xlsx`);
  };

  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData;
    }
    console.log(newData, "newData");

    setLoading(true);
    var doc = new jsPDF("l", "pt", "a3");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.marginLeft = "15rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 15;

    for (var i = 1; i <= Math.ceil(newData.length / 15); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "19rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 2rem; margin-top: 2rem; width: 1140px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">CustomerName</th>' +
        '<th style="padding: 7px;">Date</th>' +
        '<th style="padding: 7px; ">TransactionType</th>' +
        '<th style="padding: 7px;">MemoDescription</th>' +
        '<th style="padding: 7px;">Num</th>' +
        '<th style="padding: 7px; ">Amount</th>' +
        '<th style="padding: 7px;">OpenBalance</th>' +
        '<th style="padding: 7px; ">ModifiedDate</th>' +
        '<th style="padding: 7px;">CreatedBy</th>' +
        '<th style="padding: 7px;">CreatedDate</th>' +
        '<th style="padding: 7px; ">ModifiedBy</th>' +
        '<th style="padding: 7px;">Split</th>' +
        '<th style="padding: 7px; ">DueDate</th>' +
        '<th style="padding: 7px;">Account</th>' +
        '<th style="padding: 7px;">VendorMessage</th>' +
        '<th style="padding: 7px; ">Terms</th>' +
        '<th style="padding: 7px;">Payment Method</th>' +
        '<th style="padding: 7px;">Customer ID</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].CustomerName +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].Date).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].TransactionType +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].MemoDescription +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Num +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            Number(newData[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].OpenBalance +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].ModifiedDate).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].CreatedBy +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].CreatedDate).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].ModifiedBy +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Split +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].DueDate).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Account +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].VendorMessage +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Terms +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].PaymentMethod +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].CustomerID +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // Number(data[index - 1].Balance).toFixed(2) +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            // Number(data[index - 1].Amount).toFixed(2) +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // Number(data[index - 1].Balance).toFixed(2) +
            // "</td>" +
            "</tr>";
        }

        if (index % 15 == 0) {
          startIndex = startIndex + 15;
          endIndex = endIndex + 15;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      // content +=
      //   '<div style="text-align: center; width: 560px;  margin-left: 220px">' +
      //   '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
      //   i +
      //   "</p>" +
      //   "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Invoice_Received_Payments.pdf");
        setLoading(false);
      },
    });
  };

  const onBtPrint = () => {
    setLoading(true);
    var doc = new jsPDF("l", "pt", "a3");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.marginLeft = "15rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 20;

    for (var i = 1; i <= Math.ceil(data.length / 20); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "14rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 2rem; margin-top: 2rem; width: 1140px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">CustomerName</th>' +
        '<th style="padding: 7px;">Date</th>' +
        '<th style="padding: 7px; ">TransactionType</th>' +
        '<th style="padding: 7px;">Memo</th>' +
        '<th style="padding: 7px;">Num</th>' +
        '<th style="padding: 7px; ">Amount</th>' +
        '<th style="padding: 7px;">OpenBalance</th>' +
        '<th style="padding: 7px; ">ModifiedDate</th>' +
        '<th style="padding: 7px;">CreatedBy</th>' +
        '<th style="padding: 7px;">CreatedDate</th>' +
        '<th style="padding: 7px; ">ModifiedBy</th>' +
        '<th style="padding: 7px;">Split</th>' +
        '<th style="padding: 7px; ">DueDate</th>' +
        '<th style="padding: 7px;">Account</th>' +
        '<th style="padding: 7px;">VendorMessage</th>' +
        '<th style="padding: 7px; ">Terms</th>' +
        '<th style="padding: 7px;">Payment Method</th>' +
        '<th style="padding: 7px;">Customer ID</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= data.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].CustomerName +
            "</td>" +
            '<td style="font-size: 7px; padding: 5px;">' +
            moment(data[index - 1].Date).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].TransactionType +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].MemoDescription +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Num +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            Number(data[index - 1].Amount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].OpenBalance +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(data[index - 1].ModifiedDate).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].CreatedBy +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(data[index - 1].CreatedDate).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].ModifiedBy +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].Split +
            "</td>" +
            '<td style="font-size: 7px; padding: 5px;">' +
            moment(data[index - 1].DueDate).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            data[index - 1].Account +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].VendorMessage +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].Terms +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].PaymentMethod +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            data[index - 1].CustomerID +
            "</tr>";
        }

        if (index % 20 == 0) {
          startIndex = startIndex + 20;
          endIndex = endIndex + 20;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      // content +=
      //   '<div style="text-align: center; width: 560px;  margin-left: 220px">' +
      //   '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
      //   i +
      //   "</p>" +
      //   "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
        setLoading(false);
      },
    });
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Invoices and Received Payments</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Invoices and Received Payments
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3 ">
              <div className="form-group row">
                <label className="col-form-label col-md-5 form-label">
                  Report period
                </label>
                <div className="col-md-7">
                  <Select
                    options={reportdropdown}
                    defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    //  value={selectedDate}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ">
              <div className="form-group row">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            </div>

            <div className="col-sm-3">
              <button
                type="submit"
                className="btn btn-primary pull-right "
                style={{ marginLeft: "auto" }}
                onClick={apicall}
              >
                Generate Report
              </button>
            </div>
          </div>
          {/* <div style={{ display: "flex" }}>
            <button
              type="submit"
              className="btn btn-primary pull-right mb-3 w-25 mt-0"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button>
          </div> */}

          {/* Receipt */}

          <div className="card mt-5">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h2>SonarPos</h2>
                  <h6 className="fw-bold">Invoices and Received Payments</h6>
                  <div className="row mb-0">
                    {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                    <h6>
                      Date: {startdate} - {enddate}
                    </h6>
                  </div>
                </div>
              </div>
              <hr />

              {/* <div className="table-responsive">
                <div className="table mt-3"></div> */}
              {/* <div className="button">
                <button
                  onClick={onBtExport}
                  className="btn btn-sm btn-outline-dark  m-1"
                  // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-excel mr-2"></i>
                  Export to Excel
                </button>
                <button
                  onClick={downloadPDF}
                  className="btn btn-sm btn-outline-dark  m-1"
                  // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
                >
                  <i class="fas fa-file-export mr-2"></i>
                  Export to Pdf
                </button>
                <button
                  className="btn btn-sm btn-outline-dark  m-1"
                  onClick={onBtPrint}
                >
                  {" "}
                  <i class="fas fa-print mr-2"></i>Print
                </button>
              </div> */}

              {/* <div className="table-responsive">
                <table className="table mt-3">
                  <thead className="border 1px solid white">
                    <tr>
                      <th>Date</th>
                      <th>Transaction Type</th>
                      <th>MEMO/DESCRIPTION</th>
                      <th>NUM</th>
                      <th>AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseData?.map((report, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr onClick={() => toggleAccordion(index)}>
                            <td colSpan="5">
                              {renderAccordionIcon(index)} &nbsp;
                              {report.CustomerName}
                            </td>
                          </tr>
                          {activeAccordion === index && (
                            <tr>
                              <td>{report.Date}</td>
                              <td>{report.TransactionType}</td>
                              <td>{report.Memo}</td>
                              <td>{report.NUM}</td>
                              <td>{report.Amount}</td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>Total</td>
                      <td></td>
                      <td></td>

                      <td>${Number(totalSum).toFixed(2)}</td>
                      <td>${Number(totalamount).toFixed(2)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div> */}
              <div className="table-responsive">
                {/* <div className="table mt-3"> */}
                {/* <div className="container"> */}
                {/* <div className="button">
          <button
            onClick={onBtExport}
            className="btn btn-sm btn-outline-dark  m-1"
            // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
          >
            Export to Excel
          </button>
          <button
            onClick={downloadPDF}
            className="btn btn-sm btn-outline-dark  m-1"
            // style={{ marginBottom: '5px',marginLeft: "5px", fontWeight: 'bold' }}
          >
            Export to Pdf
          </button>
          <button  className="btn btn-sm btn-outline-dark  m-1" onClick={onBtPrint}>Print</button>
        </div> */}
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100vh", width: "100%" }}
                >
                  {/* <AgGridReact
                    rowData={data}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    // autoGroupColumnDef={autoGroupColumnDef}
                    onGridReady={onGridReady}
                    autoGroupColumnDef={autoGroupColumnDef}
                    rowGroupPanelShow={"always"}
                  ></AgGridReact> */}
                  <MaterialReactTable
                    muiTableContainerProps={{
                      sx: { maxHeight: "fit-content" },
                    }}
                    columns={columns}
                    data={data}
                    enableColumnResizing
                    enableGrouping
                    enableStickyHeader
                    enableStickyFooter
                    enableRowSelection
                    enableColumnOrdering
                    initialState={{
                      density: "compact",
                      expanded: true, //expand all groups by default
                      // grouping: [""], //an array of columns to group by by default (can be multiple)
                      pagination: { pageIndex: 0, pageSize: 25 },
                      sorting: [{ id: "state", desc: false }], //sort by state by default
                    }}
                    // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                    // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [25, 50, 100, 300, 500],
                    }}
                    // manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                      isError
                        ? {
                            color: "error",
                            children: "Error loading data",
                          }
                        : undefined
                    }
                    // onColumnFiltersChange={setColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={rowCount}
                    state={{
                      // columnFilters,
                      globalFilter,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                    }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          p: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        <Button
                          size="small"
                          color="primary"
                          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                          onClick={onBtExport}
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export All In Excel
                        </Button>
                        <Button
                          size="small"
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleExportRows(table.getSelectedRowModel().rows)
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export Selected Rows in Excel
                        </Button>
                        <Button
                          size="small"
                          color="primary"
                          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                          onClick={() => downloadPDF("", "alldata")}
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export All In Pdf
                        </Button>
                        <Button
                          size="small"
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            downloadPDF(
                              table.getSelectedRowModel().rows,
                              "selectedrow"
                            )
                          }
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export Selected Rows in Pdf
                        </Button>
                        {/* <Button
                          size="small"
                          onClick={() =>
                            // setPagination({ ...pagination, pageSize: totalRows })
                            setPagination({
                              ...pagination,
                              pageIndex: 0,
                              pageSize: rowCount,
                            })
                          }
                          variant="contained"
                        >
                          Get All Data
                        </Button> */}
                      </Box>
                    )}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 text-center">
                  {/* <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6> */}
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoicesandReceivedPayments;
